import { hasProductSizes, hasProductSizesNotSizeDependent } from './has-product-sizes.logic';
export default function getVariantSizeName(variant) {
  var _variant$sizeSettings;
  if (!hasProductSizes(variant)) {
    return null;
  }
  return ((_variant$sizeSettings = variant.sizeSettings) === null || _variant$sizeSettings === void 0 ? void 0 : _variant$sizeSettings.options[variant.sizeIndex]) || null;
}
export function getVariantSizeNameNotSizeDependent(variant) {
  var _variant$sizeSettings2;
  if (!hasProductSizesNotSizeDependent(variant)) {
    return null;
  }
  return ((_variant$sizeSettings2 = variant.sizeSettings) === null || _variant$sizeSettings2 === void 0 ? void 0 : _variant$sizeSettings2.options[variant.sizeIndex]) || null;
}